import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaLinkedin, FaGithub } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3 className="footer-logo">
              <span>AGKG</span> <span className="gradient-text">Créations</span>
            </h3>
            <p className="footer-desc">
              Développeur web et mobile basé à Agde, dans l'Hérault. Création de sites internet
              et applications sur mesure pour les entreprises et les particuliers.
            </p>
          </div>

          <div className="footer-nav">
            <h4>Navigation</h4>
            <Link to="/">Accueil</Link>
            <Link to="/services">Services</Link>
            <Link to="/projets">Projets</Link>
            <Link to="/tarifs">Tarifs</Link>
            <Link to="/a-propos">À propos</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-services">
            <h4>Services</h4>
            <Link to="/services" title="Développement d'applications mobiles Android et iOS">Application mobile</Link>
            <Link to="/services" title="Création d'applications web sur mesure">Application web</Link>
            <Link to="/services" title="Création de site vitrine professionnel">Site vitrine</Link>
            <Link to="/services" title="Création de boutique en ligne e-commerce">Site e-commerce</Link>
            <Link to="/tarifs" title="Voir nos tarifs de création de site et application">Nos tarifs</Link>
          </div>

          <div className="footer-contact">
            <h4>Contact</h4>
            <a href="mailto:contact@agkgcreations.fr">
              <FaEnvelope /> contact@agkgcreations.fr
            </a>
            <a href="tel:+33766803300">
              <FaPhone /> 07 66 80 33 00
            </a>
            <p>
              <FaMapMarkerAlt /> Agde, Hérault (34)
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} AGKG Créations. Tous droits réservés.</p>
          <div className="footer-bottom-links">
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/mentions-legales">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
